import { createComponent } from '@mtfe/sweet';
import { common, dom, eventBus } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';

const { createUniqueId } = common;

const PoiListHeader = (props) => {
    const { headerText, isShowTips, leftRecvNum } = props;
    const tipsId = createUniqueId();
    const data = {
        tipsId,
        isShowTips: isShowTips ? 'flex' : 'none',
        headerText,
        leftRecvNum,
    };
    const events = {};
    eventBus.$on('selfCoupon-changeTimes', (times) => {
        const leftRecvDom = dom.$id(tipsId);
        if (leftRecvDom) {
            leftRecvDom.innerHTML = `可选<span>${times}</span>次`;
        }
    });
    const component = createComponent(tpl, { data, style }, events);
    return component;
};

export default PoiListHeader;
